import { Injectable } from '@angular/core';
import { Invoice, InvoiceService, SelectedCustomerService } from 'gung-standard';
import { TranslateService } from '@ngx-translate/core';
import { JeevesInvoiceListConfigService } from 'gung-standard-jeeves';
import { ConfigBaseFilter, SimpleConfigBaseFilter } from 'gung-list';

export class InvoiceTypeFilter extends SimpleConfigBaseFilter<Invoice> {
  constructor(protected translateService: TranslateService) {
    super();
  }

  getName(): string {
    return 'FH_FAKTURATYP';
  }

  getOptionIds(item: Invoice): string[] {
    if (item.extra.fh.fakturatyp == null) {
      return ['UNDEFINED'];
    }

    if ([10, 12, 14, 100].includes(item.extra.fh.fakturatyp)) {
      return ['REF_FH_FAKTURATYP_INVOICE'];
    } else if ([0, 120, 156, 876].includes(item.extra.fh.fakturatyp)) {
      return ['REF_FH_FAKTURATYP_CREDIT'];
    }
    return [`FH_FAKTURATYP_${item.extra.fh.fakturatyp}`];
  }

  getOptionName(key: string): string {
    return this.translateService.instant(key);
  }
}

@Injectable({
  providedIn: 'root'
})
export class RefJeevesInvoiceListConfigService extends JeevesInvoiceListConfigService {

  getFilters(): ConfigBaseFilter<Invoice>[] {
    return [...super.getFilters(), new InvoiceTypeFilter(this.translationService)];
  }
}
